import { useQuery } from "@tanstack/react-query";
import Cookies from "js-cookie";
import { useRouter } from "next/router";

import { getDomain } from "../../core/cookies.core";
import { getShop } from "../../core/shop.core";
import { useTranslation } from "../../core/translation.core";
import { profileGridCss, selectCss } from "../reuseables/native.comp";

export default function Locale() {
  const router = useRouter();
  const { t, msg } = useTranslation();

  const { data: shop } = useQuery({
    queryKey: ["shop"],
    queryFn: getShop,
  });

  const localeLabels = {
    en: t(msg.setting.english),
    "zh-Hans": t(msg.setting.chineseS),
    "zh-Hant": t(msg.setting.chineseT),
  };

  function changeLocale(value: string) {
    router.push({ pathname: router.pathname, query: router.query }, router.asPath, { locale: value });
    Cookies.set("NEXT_LOCALE", value, {
      domain: getDomain(),
      expires: 9999,
      sameSite: "strict",
    });
  }

  if (!shop) return null;

  return (
    <div className={profileGridCss}>
      <h2>{t(msg.setting.chooseLanguage)}</h2>
      <select id="select-locale" className={selectCss} onChange={(e) => changeLocale(e.target.value)} value={router.locale}>
        {shop.locales.map((locale) => (
          <option key={locale} value={locale}>
            {localeLabels[locale] || locale} {/* Display label or fallback to locale code */}
          </option>
        ))}
      </select>
    </div>
  );
}
